import type { DateTime } from 'luxon';
import { TranslationService } from '../../../../../../services/translation.service';

function ActualTripSelectorSummary({
  arrivalDateTime,
  showOnlyTimeInSummary,
  comments,
  onEditClick,
}: {
  arrivalDateTime: DateTime;
  showOnlyTimeInSummary: boolean;
  comments: string;
  onEditClick?: () => void;
}) {
  // === VARIABLES ===
  const whenString = showOnlyTimeInSummary ? `${arrivalDateTime.toFormat('HH:mm')}` : `${arrivalDateTime.toFormat('EEEE dd MMMM yyyy HH:mm')}`;

  return (
    <div className="delay-compensation-form__actual-arrival-selector-summary p-2 rounded border">
      <p className="visually-hidden">{TranslationService.get('customerserviceforms.actualtripselectorsummarycaption')}</p>
      <div className="mb-2">
        <span className="fw-bold">{TranslationService.get('delaycompensationformpage.actualarrivaltimetext')}: </span>
        <span>{whenString}</span>
      </div>
      <div className="mb-2">
        <div className="fw-bold">{TranslationService.get('delaycompensationformpage.actualarrivalreasonfordelay')}:</div>
        <div>{comments}</div>
      </div>
      <div className="text-end">
        <button className="btn--as-link" onClick={onEditClick}>
          {TranslationService.get('common.edit')}
        </button>
      </div>
    </div>
  );
}

export default ActualTripSelectorSummary;
